import { jsx as n, jsxs as O } from "react/jsx-runtime";
import o from "clsx";
import { C as v, T as P, s as B, a4 as H, q as $, o as z, L as A, v as L, w as _, O as j, P as q, f as R, a9 as V, S as M, G as U, aa as D } from "./helpers-458d7e27.js";
import { T as J, i as K } from "./TextHeaderInner-7887aa3a.js";
import "react";
import "@emotion/react";
import "@paypalcorp/pp-react-theme";
import "@paypalcorp/pp-react-icons";
import "react-dom";
import "./TextGroup-dd19925e.js";
import "./AppDownload-79ac7787.js";
import "./pp-react-text-input.esm-853a9847.js";
import "./card-renderer-3ad4b108.js";
import "./PpReactCurrencyInput-cfa9b61d.js";
const Q = {
  start: 1,
  span: 7
}, X = 311.5, Y = {
  sm: { slideWidth: X }
}, Z = {
  options: {
    topSpacing: "0vw"
  }
}, k = "OfferCardSectionItem", a = new v(k), y = ({
  className: t = "",
  offerTitle: e,
  offerTitleTag: c = "h3",
  offerTitleSize: r = "Headline 7",
  availability: s,
  cardTheme: C = "white",
  mediaFrame: m,
  url: g = "",
  target: l = "_blank",
  ariaLabel: p = "",
  analyticsCompName: i = k,
  arrowPosition: d = "bottom",
  isVisibleSlide: u,
  serverFptiData: N = {}
}) => {
  const f = o(
    P.getThemeClassName(C),
    t,
    a.getComponentClassName()
  ), {
    environment: { host: h = "", pageSegment: T = "" } = {},
    requestor: { locality: { country: x = void 0 } = {} } = {}
  } = B(), S = o(
    a.getElementClassName("anchorTagWrapper")
  ), w = (F) => i && L(
    {
      componentName: i,
      linkText: F,
      linkType: j.Tertiary,
      clickEvent: q.Text,
      serverFptiData: N
    },
    T,
    _.CTA
  ), G = () => e ? /* @__PURE__ */ n(
    R,
    {
      as: c,
      className: o(a.getElementClassName("headline"), {
        [a.getElementClassName("headlineRightSpacing")]: d === "top" || !s,
        [a.getElementClassName("headlineNoAvailability")]: !s
      }),
      content: e,
      customWrapper: V({ size: r }),
      analyticsCompName: i,
      analyticsTextSection: "offerTitle"
    }
  ) : null, W = p || `${e}, ${s}`, b = u ? {} : { tabIndex: -1 };
  return (
    // removed rel="noreferrer" since all target links are partner sites
    // eslint-disable-next-line react/jsx-no-target-blank
    /* @__PURE__ */ n(
      "a",
      {
        className: S,
        "aria-label": W,
        "data-pa-click": w(p),
        target: l,
        href: H(g, h, x),
        rel: l === "_self" ? "" : "noopener",
        ...b,
        children: /* @__PURE__ */ O("div", { className: f, "aria-hidden": !0, children: [
          m && /* @__PURE__ */ n(
            $,
            {
              motionOptions: {
                motionFeel: "Functional",
                motionTypePreset: "appear",
                motionIntensity: "xs"
              },
              className: o(a.getElementClassName("image")),
              ...m
            }
          ),
          G(),
          s && /* @__PURE__ */ n(
            z,
            {
              size: "Body",
              className: o(a.getElementClassName("caption")),
              children: s
            }
          ),
          /* @__PURE__ */ n(
            A,
            {
              size: "Large",
              className: o(d === "top" && "arrow-icon-position-top")
            }
          )
        ] })
      }
    )
  );
};
y.displayName = k;
const I = "OfferCardSection", E = new v(I), ee = (t) => {
  let e = t;
  return K(t) || (e = {
    textGroup: t,
    ...Q
  }), /* @__PURE__ */ n(
    J,
    {
      className: E.getElementClassName("header"),
      ...e,
      textGroup: {
        ...e.textGroup,
        analyticsCompName: I
      }
    }
  );
}, te = (t, e) => function({ itemProps: r, carouselState: s }) {
  return /* @__PURE__ */ n(
    y,
    {
      ...r,
      cardTheme: t,
      arrowPosition: e,
      isVisibleSlide: s == null ? void 0 : s.isVisibleSlide
    }
  );
}, se = (t) => /* @__PURE__ */ n(U, { children: /* @__PURE__ */ n(D, { ...t }) }), ne = ({
  className: t = "",
  headline: e,
  collection: c = [],
  carouselDetails: r,
  disclosureType: s,
  topSpacer: C = "4vw",
  bottomSpacer: m = "4vw",
  componentId: g,
  graphicVersionBottom: l,
  graphicColorBottom: p,
  graphicVersionTop: i,
  graphicColorTop: d,
  theme: u = "white",
  cardTheme: N = "neutral 100",
  arrowPosition: f = "bottom"
}) => {
  const h = { topSpacing: C, bottomSpacing: m }, T = o(E.getComponentClassName(), t), x = {
    items: c,
    renderItem: te(N, f),
    carouselDetails: r,
    breakpoints: Y,
    classes: { container: o(E.getElementClassName("carousel")) }
  };
  return /* @__PURE__ */ O(
    M,
    {
      id: g,
      disclosure: s,
      theme: u,
      options: h,
      disclosureGridItemProps: Z,
      ...{
        graphicVersionBottom: l,
        graphicColorBottom: p,
        graphicVersionTop: i,
        graphicColorTop: d
      },
      className: T,
      children: [
        e && ee(e),
        se(x)
      ]
    }
  );
};
ne.displayName = I;
export {
  ne as default
};
//# sourceMappingURL=OfferCardType.js.map
